<div class="container-fluid inactivity-page">
  <div class="container middle-section bg-white rounded">
    <div class="text-center m-5">
      <img src="./assets/images/ushg/vcall-logo.png" alt="image" width="200" />
    </div>
    <div class="card-body">
      <p>Your session has ended. To continue using the application, please log in again.</p>
    </div>
    <div class="card-footer">
      <button
        class="btn btn-primary"
        (click)="loginNow()"
        style="padding: 10px 30px; font-size: 1rem;"
      >
        Login now
      </button>
    </div>
  </div>
</div>
